export default class MouseTracker {
  constructor() {
    /** @type {number[][]} */
    this.coordinates = [];
    this.lastPoint = { x: 0,y: 0 };
  }

  reset (x,y) {
    this.coordinates = [];
    this.coordinates.push([x,y]);
  }

  addPoint (x,y) {
    this.lastPoint.x = x;
    this.lastPoint.y = y;
    this.coordinates.unshift([x,y]);
  }
}